import { Link } from "react-router-dom";
import ArrowRightIcon from '@mui/icons-material/ArrowRight';

import { ROUTES } from '~/const';
import { getLink, trans } from "~/providers/lang";

import "./style.less";

export default function BubbleContact() {
	return <div className="bubble-contact">
		<h2>
			{trans('home.opening.title')}
		</h2>
		<p className="open-time" dangerouslySetInnerHTML={{ __html: trans('home.opening.openTime') }} />
		<p className="adress-info" dangerouslySetInnerHTML={{ __html: trans('home.opening.address') }} />
		<p className="contact">
			<Link to={getLink(ROUTES.contacts)} className="map-link">
				<span dangerouslySetInnerHTML={{ __html: trans('home.opening.page') }} />
				<ArrowRightIcon sx={{ color: "#fff" }} className="map-link-icon" />
			</Link>
		</p>
	</div>;
}
